import { render, staticRenderFns } from "./ChannelState.vue?vue&type=template&id=23ecec48&scoped=true"
import script from "./ChannelState.vue?vue&type=script&lang=js"
export * from "./ChannelState.vue?vue&type=script&lang=js"
import style0 from "./ChannelState.vue?vue&type=style&index=0&id=23ecec48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ecec48",
  null
  
)

export default component.exports